import { POPUP_CONTENT } from "../../config/popupContent";
import { trackModalOpen } from './yandexMetricsHandle';

let scrollModalScheduled = false;

let automaticModalTimerId = null;

function showModalByScroll() {
    const reachedTargetSpotOfPage = (spot) => window.pageYOffset + document.documentElement.clientHeight >= spot * document.documentElement.scrollHeight;
    if (reachedTargetSpotOfPage(0.6) && !scrollModalScheduled) {
        scrollModalScheduled = true;
        window.removeEventListener('scroll', showModalByScroll);
        setTimeout(
            () => openModal(
                '.modal',
                automaticModalTimerId,
                undefined,
                true
            ),
            1000
        );
    }
}

const modalTitle = document.querySelector(`.modal__title`);
const modalSubtitle = document.querySelector(`.modal__subtitle`);
const modalBtn = document.querySelector('.button_mdl');
const modalDefaultTitleText = modalTitle?.textContent ?? '';
const modalDefaultSubtitleText = modalSubtitle?.textContent ?? '';
const modalDefaultBtnText = modalBtn?.textContent ?? '';


function openModal(
    modalSelector,
    modalTimerId,
    source,
    useSoftOpen = false
) {
    const modalElement = document.querySelector(modalSelector);

    if (!modalElement) {
        return;
    }

    modalElement.classList.toggle(
        'modal_soft-open',
        useSoftOpen
    );    

    const wasAlreadyOpen = modalElement.classList.contains('show');

    const content = POPUP_CONTENT[source];

    if (content && modalTitle && modalSubtitle && modalBtn) {
        modalTitle.textContent = content.title;
        modalSubtitle.textContent = content.description;
        modalBtn.textContent = content.btnText;
    }

    modalElement.classList.add('show');
    modalElement.classList.remove('hide');
    document.body.style.overflow = 'hidden';
    window.removeEventListener('scroll', showModalByScroll);

    if (!wasAlreadyOpen) {
        trackModalOpen(source);
    }

    // console.log(modalTimerId);
    if (modalTimerId) {
        clearTimeout(modalTimerId);
    }
}

function closeModal(modalSelector) {
    const modalElement = document.querySelector(modalSelector);
    modalElement
        .querySelector('.modal__dialog_result')
        ?.remove();

    modalElement
        .querySelector('.modal__dialog:not(.modal__dialog_result)')
        ?.classList.remove('hide');

    history.replaceState(
        {},
        '',
        window.location.pathname
    );


    modalElement.classList.remove('show');
    modalElement.classList.add('hide');
    document.body.style.overflow = '';

    if (modalTitle && modalSubtitle && modalBtn) {
        modalTitle.textContent = modalDefaultTitleText;
        modalSubtitle.textContent = modalDefaultSubtitleText;
        modalBtn.textContent = modalDefaultBtnText;
    }
}

function modal(triggerSelector, modalSelector, modalTimerId) {
    const modalElement = document.querySelector(modalSelector);

    automaticModalTimerId = modalTimerId;

    let isFormReceived = false;

    try {
        isFormReceived =
            localStorage.getItem('isFormReceived') === 'true';
    } catch (error) {
        console.warn('Не удалось прочитать состояние формы', error);
    }

    if (isFormReceived && modalTimerId) {
        clearTimeout(modalTimerId);
    }    

    const btnBack = document.querySelector('[data-back]');

    const referrerUrl = document.referrer
        ? new URL(document.referrer)
        : null;

    const isBlogReferrer =
        referrerUrl?.origin === window.location.origin &&
        referrerUrl.pathname.startsWith('/blog/');


    if (btnBack && !isBlogReferrer) {
        btnBack.remove();
    }


    // Modal

    const modalTriggers = document.querySelectorAll(triggerSelector);


    modalTriggers.forEach(trigger => (
        trigger.addEventListener('click', () => {
            openModal(modalSelector, modalTimerId);
        })
    ));

    modalElement.addEventListener('click', (e) => {
        const target = e.target;

        if (target.closest?.('[data-back]')) {
            history.back();
            return;
        }

        if (target === modalElement || target.closest?.('[data-close]')) {
            closeModal(modalSelector);
        }

    });

    document.addEventListener('keydown', (e) => {
        if (e.code === 'Escape' && modalElement.classList.contains('show')) {
            closeModal(modalSelector);
        }
    });

    // открытие popup по query параметру из url

    const searchParams = new URLSearchParams(window.location.search);
    const isNeedToOpenByCta = searchParams.get('open_form') === 'true';
    const source = searchParams.get('source');
    const isAppBetaSource = source === 'app_beta';
    const modalSources = Object.keys(POPUP_CONTENT);

    const hasExistingSource = modalSources.some(src => src === source);

    if (hasExistingSource) {
        openModal(
            modalSelector,
            isAppBetaSource ? null : modalTimerId,
            source
        );
    } else if (isNeedToOpenByCta) {
        openModal(modalSelector, modalTimerId);
    } 

    const openedByQuery = isNeedToOpenByCta || hasExistingSource;

    if (!isFormReceived &&
        (!openedByQuery || isAppBetaSource) && 
        window.location.pathname !== '/learning/' && 
        window.location.pathname !== '/learning'
    ) {
        window.addEventListener('scroll', showModalByScroll);
    }

}

export default modal;
export {openModal, closeModal};